/**
 * The stand-in for an opened type or scenario while the server's answer is on its way,
 * as on a deep link. It wears the level header so the way back works before anything loads.
 */

import { Skeleton } from '@/components/ui/skeleton';
import { LevelHeader } from './level-header';

export const DetailSkeleton = ({ onBack, label }: { onBack: () => void; label: string }) => (
	<div className='flex min-h-0 flex-1 flex-col'>
		<LevelHeader
			onBack={onBack}
			backLabel={label}
			title={<Skeleton className='h-3.5 w-2/3' />}
			subtitle={<Skeleton className='mt-1 h-3 w-1/2' />}
		/>
		<div className='flex flex-col gap-2 p-3'>
			{Array.from({ length: 4 }, (_, i) => (
				<Skeleton key={i} className='h-11' />
			))}
		</div>
	</div>
);
